import React from "react";
import { Group, Text, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { PreferenceRow } from "./preferenceRows";
import styles from "./NotificationSettings.module.css";

/**
 * A notification type's name with an info tooltip explaining exactly which
 * events trigger it. Same tooltip treatment as SettingsField's `info`.
 */
export const NotificationRowLabel: React.FC<{ row: PreferenceRow }> = ({
  row,
}) => (
  <Group gap={6} wrap="nowrap">
    <Text fw={500} size="sm">
      {row.label}
    </Text>
    <Tooltip
      label={row.description}
      multiline
      w={260}
      withArrow
      events={{ hover: true, focus: true, touch: true }}
    >
      <IconInfoCircle
        size="1rem"
        className={styles.infoIcon}
        aria-label={`About ${row.label} notifications`}
        tabIndex={0}
      />
    </Tooltip>
  </Group>
);

export default NotificationRowLabel;
